import { render, staticRenderFns } from "./ReEvaluationEdit.vue?vue&type=template&id=0248fd10&scoped=true&"
import script from "./ReEvaluationEdit.vue?vue&type=script&lang=js&"
export * from "./ReEvaluationEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReEvaluationEdit.vue?vue&type=style&index=0&id=0248fd10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248fd10",
  null
  
)

export default component.exports